/* JS */
import Aigor from './_modules/Aigor.js';

new Aigor();
